module.exports = __webpack_public_path__ + "img/pdf-icon.743869c4.svg";